import { Copy, Trash2, FileAudio, FileText } from "lucide-react";
import { formatDate, mediaUrl } from "@/lib/api";

const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} Mo` : `${Math.round(b / 1024)} Ko`);

const Thumb = ({ file }) => {
  if (file.content_type?.startsWith("image")) return <img src={mediaUrl(file.url)} alt="" className="w-full h-full object-cover" />;
  if (file.content_type?.startsWith("audio")) return <FileAudio size={40} />;
  return <FileText size={40} />;
};

export const MediaCard = ({ file, index, onCopy, onDelete }) => (
  <div data-testid={`media-item-${index}`} className="bg-white border border-zinc-200 group">
    <div className="aspect-[4/3] bg-zinc-100 flex items-center justify-center overflow-hidden text-zinc-400"><Thumb file={file} /></div>
    <div className="p-3">
      <div className="text-xs font-semibold truncate" title={file.original_filename}>{file.original_filename || "fichier"}</div>
      <div className="text-[11px] text-zinc-500">{fmtSize(file.size)} · {formatDate(file.created_at)}</div>
      <div className="flex gap-1 mt-2">
        <button data-testid={`media-copy-${index}`} onClick={() => onCopy(file.url)} className="flex-1 inline-flex items-center justify-center gap-1 border px-2 py-1.5 text-xs font-bold hover:border-red-600 hover:text-red-600"><Copy size={12} /> Copier le lien</button>
        <button data-testid={`media-delete-${index}`} onClick={() => onDelete(file.id)} aria-label="Supprimer" className="border px-2 py-1.5 hover:bg-red-600 hover:text-white"><Trash2 size={12} /></button>
      </div>
    </div>
  </div>
);
